import { render, staticRenderFns } from "./GywmContent.vue?vue&type=template&id=522a159b&scoped=true&"
import script from "./GywmContent.vue?vue&type=script&lang=js&"
export * from "./GywmContent.vue?vue&type=script&lang=js&"
import style0 from "./GywmContent.vue?vue&type=style&index=0&id=522a159b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522a159b",
  null
  
)

export default component.exports